import { render, staticRenderFns } from "./VehicleSelect.vue?vue&type=template&id=5afb4aba"
import script from "./VehicleSelect.ts?vue&type=script&lang=ts&external"
export * from "./VehicleSelect.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports